



import EventEditComponent from "@/components/admin/event/eventEditComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LiveListPage",
  components: {
    EventEditComponent,
  },
})
export default class EventEditPage extends Vue {}
